import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext'; // Assuming it's in the same folder

interface ProtectedRouteProps extends RouteProps {
    component: React.ComponentType<any>;
}

const ProtectedRoute = ({ component: Component, ...rest }: ProtectedRouteProps) => {
    const { isAdmin, isLoading } = useAdminAuth();

    console.log("isAdmin:", isAdmin, "isLoading:", isLoading);

    if (isLoading) {
        // While we check, we'll show a lovely loading spinner
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div className="spinner-border" style={{ width: '3rem', height: '3rem' }} role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <Route
            {...rest}
            render={props =>
                isAdmin ? (
                    <Component {...props} />
                ) : (
                    // If not an admin, show them a no permission screen
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <h1>Access Denied</h1>
                        <p>You do not have permission to view this page.</p>
                    </div>
                )
            }
        />
    );
};

export default ProtectedRoute;